import AccessibilityPage from 'info/accessibility';

export default AccessibilityPage;
